import React, { Component } from "react";
import { Grid } from "react-bootstrap";

import { BarInformationsTable } from "admin/components/attorney-verification-manager";
import { createPaginationForForm } from "admin/components/attorney-verification-manager/BarInformationsTable";
import {
  recentBarInformationInitialParams,
  withRecentBarInformations,
} from "admin/connectors";
import { VerificationSearchForm } from "admin/forms";

const formName = "recentBarInformationSearchForm";
const Pagination = createPaginationForForm(formName);

class RecentlyProcessedBarInformations extends Component {
  handleOffsetChange = offset => {
    this.props.changeFieldValue("offset", offset);
    setTimeout(this.props.submitSearchForm);
  };

  handleSubmit(values) {
    this.props.onSearchSubmit({ params: values });
  }

  render() {
    const {
      recentBarInformations,
      recentBarInformations: {
        data: { count, results },
        ready,
      },
    } = this.props;
    const initialFormData = {
      ...recentBarInformationInitialParams,
      text: "",
      start_date: null,
      end_date: null,
      offset: 0,
    };
    return (
      <Grid fluid>
        <h2>
          Recently Processed Bar Licenses{" "}
          {ready && (
            <small>
              showing {results.length} / {count}
            </small>
          )}
        </h2>
        <VerificationSearchForm
          form={formName}
          onSubmit={values => this.handleSubmit(values)}
          initialValues={initialFormData}
        />
        <BarInformationsTable
          barInformations={recentBarInformations}
          type="pending"
        />
        {ready && (
          <Pagination onOffsetChange={this.handleOffsetChange} length={count} />
        )}
      </Grid>
    );
  }
}

export default withRecentBarInformations()(RecentlyProcessedBarInformations);
